<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-0">
        <college-course-card
          :country-name="countryName"
          :country-id="countryId"
          :country-flag="countryFlag"
          :school="school"
          :loading="loading"
          :counts="counts"
          :resource-type="$t('courses.courses')"
        />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-4">
      <v-col cols="12">
        <v-card class="elevation-3 rounded-lg">
          <v-card-title class="deep-purple white--text">
            <v-icon left color="white">mdi-school</v-icon>
            {{ $t('courses.coursesList') }}
          </v-card-title>

          <v-card-text class="pa-6">
            <college-courses-table
              :school-id="schoolId"
              :loading="loading"
              @course-updated="handleCourseUpdated"
              @counts-updated="updateCounts"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CollegeCourseCard from '@/components/colleges/courses/CollegeCourseCard.vue';
import CollegeCoursesTable from '@/components/colleges/courses/CollegeCoursesTable.vue';
import { mapGetters } from 'vuex';
import schoolService from '@/services/school.service';
import { FLAGS_URL } from '@/constants/data';

export default {
  name: 'CollegeCoursesDetail',
  components: {
    CollegeCourseCard,
    CollegeCoursesTable,
  },
  data: () => ({
    loading: false,
    schoolData: {},
    flagsPath: `${FLAGS_URL}countries_flags/`,
    counts: {
      active: 0,
      total: 0,
      totalCourses: 0,
    },
  }),
  computed: {
    ...mapGetters('enrollment', ['getSchoolSelected']),
    school() {
      // Priorizar la información cargada localmente sobre la del store
      if (this.schoolData && Object.keys(this.schoolData).length > 0) {
        return this.schoolData;
      }
      return this.getSchoolSelected || {};
    },
    schoolId() {
      const routeCollegeId = this.$route.params.collegeId;
      const schoolId = this.school?.id;

      // Priorizar el collegeId de la ruta
      if (routeCollegeId) {
        return routeCollegeId;
      }

      // Fallback al school del store
      if (schoolId) {
        return schoolId;
      }

      return null;
    },
    countryName() {
      return this.school?.country?.name || '';
    },
    countryId() {
      return this.school?.country?.id || '';
    },
    countryFlag() {
      const country = this.school?.country;
      if (country && country.iso_code) {
        return `${this.flagsPath}${country.iso_code}.png`;
      }
      return '';
    },
  },
  watch: {
    schoolId: {
      handler(newSchoolId) {
        if (newSchoolId) {
          this.loadSchoolData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadSchoolData() {
      if (!this.schoolId) {
        return;
      }

      this.loading = true;
      try {
        const response = await schoolService.findOne(this.schoolId);
        if (response.status === 200 && response.data) {
          this.schoolData = response.data;
          // También actualizar el store si es necesario
          this.$store.dispatch('enrollment/setCurrentCollege', { college: response.data });
        }
      } catch (error) {
        console.error('Error loading school data:', error);
        if (this.$toast) {
          this.$toast.error('Error al cargar la información del colegio');
        }
      } finally {
        this.loading = false;
      }
    },
    handleCourseUpdated() {
      this.$emit('course-updated');
    },
    updateCounts(newCounts) {
      this.counts = { ...this.counts, ...newCounts };
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
